import CustomPagination from '@/Component/Common/Tables/CustomPagination'
import SearchInput from '@/Component/Common/Forms/SearchInput'
import Loader from '@/Layout/Loader'
import HOCButton from './HOCButton'

const TableHoc = (WrappedComponent) => {

    return function NewWrapper(props) {
        const { apiData = {}, searchBtnProps = {}, buttonRequired, btnProps, enableMultiDelete = false, onMultiDelete, ...rest } = props;

        const buttons = searchBtnProps?.buttons || (
            searchBtnProps?.title
                ? [{
                    title: searchBtnProps?.title,
                    callBack: searchBtnProps?.callBack,
                    path: searchBtnProps?.path
                }]
                : []
        );

        const showButtons = searchBtnProps?.buttonRequired !== false && buttons.length > 0;

        return (
            <>
                <div className='flex items-center justify-between mb-5'>
                    <SearchInput setParams={apiData?.setParams} setSearch={searchBtnProps?.setSearch} customInputMainClass="flex-1" customClass="md:!w-72 !bg-white" />
                    <div className="flex items-center">
                        {(enableMultiDelete && rest?.selectedItems?.length > 0) && (
                            <button className="bg-red-500 rounded-3xl py-2.5 sm:px-4 px-3 text-sm font-medium focus-visible:outline-none hover:shadow-[0_0_0_3px_rgba(185,218,255,1)] transition-shadow border-red-500 text-white disabled:opacity-75" disabled={!rest?.selectedItems?.length} onClick={() => onMultiDelete?.(rest?.selectedItems)}>Delete Selected </button>
                        )}
                        {showButtons && buttons?.map((btn, i) => (
                            <HOCButton key={i} buttonRequired={searchBtnProps?.buttonRequired} btnProps={{ title: btn.title, callBack: btn.callBack, path: btn.path }} />
                        ))}
                    </div>
                </div>
                {(apiData?.isPending || apiData?.fetchStatus == 'fetching') && <Loader />}
                <div className="relative overflow-hidden overflow-x-auto border border-lightGray rounded-lg bg-white">
                    <WrappedComponent apiData={apiData} enableMultiDelete={enableMultiDelete} {...rest} />
                </div>
                {apiData?.data?.total > apiData?.params?.per_page &&
                    <CustomPagination total={apiData?.data?.total} currentPageObj={apiData?.params} setParams={apiData?.setParams} />}
            </>
        )
    }
}

export default TableHoc
